<div class="product-option-cont" [ngClass]="{'selected': isSelected}"
     (mouseenter)="productOptionService.EmitOptionItemMouseOverEvent(this.product)"
     (mouseleave)="productOptionService.EmitOptionItemMouseOutEvent(product)"
     (click)="itemSelected()"
>
    <img width="50" src="{{this.product.getImage()}}"/>
</div>

